export const ignoreKeyPressIfNotInteger = (event: KeyboardEvent) => {
	if (!Number.isInteger(parseInt(event.key))) {
		event.preventDefault();
	}
};
